var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdb-select',{staticClass:"light",attrs:{"id":"languageSelector","color":"primary"},on:{"getValue":_vm.onLanguageChanged},model:{value:(_vm.languages),callback:function ($$v) {_vm.languages=$$v},expression:"languages"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }